import {
  onboardingBookingDestinationSchema,
  onboardingBookingProductSchema,
} from "@redotech/redo-onboarding-api/booking-destination";
import * as z from "zod";

export const getOnboardingBookingDestination = {
  name: "getOnboardingBookingDestination" as const,
  input: z.object({ productId: onboardingBookingProductSchema }),
  output: onboardingBookingDestinationSchema,
};

export const setOnboardingBookingDestination = {
  name: "setOnboardingBookingDestination" as const,
  input: onboardingBookingDestinationSchema,
  output: onboardingBookingDestinationSchema,
};
